"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M6.9957 15.5932 17.3189 5.2699c.3721-.372.9895-.3577 1.3792.032.3897.3897.404 1.0071.032 1.3792L8.4068 17.0043h3.2356c.5511 0 .9978.4468.9978.9979S12.1935 19 11.6424 19H5.9978C5.4468 19 5 18.5533 5 18.0022v-5.6446c0-.5511.4467-.9978.9978-.9978s.9979.4467.9979.9978v3.2356Z", clipRule: "evenodd" })), 'ArrowDiagonalDownIcon');
